import type { DialogConfig } from '../shared/types';

export const DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'onboarding',
	dialogId: 'collection-trial-modal',
	dialogType: 'modal',
};
